import { showAlert, ALERT_TYPES } from './alert.js';
import errorRegistry from '../json/errors.json';

export function handleError(error, targetId) {
    let title = "خطا!";
    let message = errorRegistry.CLIENT_UNKNOWN_ERROR;

    if (error.details && error.details.code) {
        const serverErrorCode = error.details.code;
        message = errorRegistry[serverErrorCode] || error.message;

    } else if (error.message.includes('Failed to fetch')) {
        message = errorRegistry.CLIENT_NETWORK_ERROR;

    } else if (error.name === 'AbortError') {
        message = errorRegistry.CLIENT_TIMEOUT_ERROR;

    } else if (error.message) {
        message = error.message;
    }

    showAlert(targetId, ALERT_TYPES.ERROR, title, message);
}